import {FINISH_UPLOADING, START_UPLOADING} from 'shared/actions/minerva';
import {booleanReducer} from 'shared/reducers/boolean-reducer';
import {loadingReducer} from 'shared/reducers/loading';
import {notificationsReducer} from 'shared/reducers/notifications';
import {popoversReducer} from 'shared/reducers/popovers';
import currentInstitutionReducer from 'src/redux/admin/reducers/current-institution';
import toolbarNotificationReducer from 'src/redux/toolbar-notification/reducer';
import universityReducer from 'src/redux/admin-university/reducers/university';
import photoListingsReducer from 'src/redux/admin-university/reducers/photo-listing';
import {listReducer} from '../../redux/lists';
import checklistReducer from '../../redux/checklist/reducer';
import checklistUserStatusReducer from '../../redux/checklist-user-status/reducer';
import featureFlagsReducer from 'src/redux/admin/reducers/feature-flags';

export const adminReducers = {
  checklist: checklistReducer,
  checklistUserStatus: checklistUserStatusReducer,
  currentInstitution: currentInstitutionReducer,
  featureFlags: featureFlagsReducer,
  lists: listReducer,
  loading: loadingReducer,
  notifications: notificationsReducer,
  photoListings: photoListingsReducer,
  popovers: popoversReducer,
  toolbarNotification: toolbarNotificationReducer,
  university: universityReducer,
  uploading: booleanReducer({
    defaultState: false,
    falseType: FINISH_UPLOADING,
    trueType: START_UPLOADING,
  }),
};
